// Application constants
export const PROTOCOL = "http://";
export const HOSTNAME = "localhost";

// Development server configuration
export const DEV_SERVER_PORT = 4200;
export const DEV_SERVER_URL = `${PROTOCOL}${HOSTNAME}:${DEV_SERVER_PORT}`;

// Visol server configuration
export const SERVER_PORT = 51501;
export const SERVER_URL = `${PROTOCOL}${HOSTNAME}:${SERVER_PORT}`;

// Managed URLs
export const CANCEL_LOGIN_URL = "/cancel-login";
export const DESKTOP_LOGIN_URL = "/desktop-login";
export const LOGIN_PAGE_URL = "/login";
